import React from 'react';
import ArrowDropDownOutlined from '../../Icons/ArrowDropDownOutlined';
export default function Autocomplete(theme) {
    return {
        MuiAutocomplete: {
            defaultProps: {
                popupIcon: /*#__PURE__*/ React.createElement(ArrowDropDownOutlined, null)
            },
            styleOverrides: {
                root: ({ ownerState })=>{
                    return {
                        ...ownerState['data-gef-variant'] === 'static' && ownerState.size === 'small' ? {
                            '& .MuiInputLabel-filled': {
                                marginBottom: 0
                            },
                            '&.MuiAutocomplete-root .MuiFilledInput-root .MuiAutocomplete-endAdornment': {
                                right: '1px'
                            }
                        } : {},
                        variants: [
                            {
                                props: {
                                    'data-gef-variant': 'static'
                                },
                                style: {
                                    '& .MuiInputBase-root.Mui-disabled': {
                                        backgroundColor: theme.palette.background[50],
                                        textFillColor: theme.palette.text.primary,
                                        borderRadius: 6
                                    },
                                    '& .MuiFilledInput-root': {
                                        paddingTop: '2px',
                                        paddingBottom: '2px',
                                        paddingLeft: theme.spacing(1),
                                        '&.MuiInputBase-sizeSmall .MuiFilledInput-input': {
                                            paddingTop: '1.5px',
                                            paddingBottom: '1.5px',
                                            paddingLeft: theme.spacing(0.5)
                                        },
                                        '& .MuiFilledInput-input': {
                                            paddingTop: '5.5px',
                                            paddingBottom: '5.5px',
                                            paddingLeft: theme.spacing(0.5)
                                        }
                                    },
                                    '& .MuiFilledInput-root.MuiInputBase-sizeSmall': {
                                        paddingBottom: '2px',
                                        paddingLeft: theme.spacing(0.5)
                                    },
                                    '& .MuiAutocomplete-tag': {
                                        marginLeft: '1px',
                                        marginRight: '1px',
                                        marginTop: '1px',
                                        marginBottom: '1px'
                                    }
                                }
                            }
                        ]
                    };
                },
                paper: {
                    boxShadow: theme.customShadows.dropdown
                },
                listbox: {
                    padding: theme.spacing(0, 1),
                    '& .MuiAutocomplete-option': {
                        padding: theme.spacing(1),
                        margin: theme.spacing(1, 0),
                        borderRadius: theme.radius(1)
                    }
                }
            }
        }
    };
}
